<template>
  <div class="bill">
    <div class="top">
      <div class="left">
        <h3>发票详情</h3>
        <p>
          可申请发票金额：
          <span>￥<span ref="price">{{userBaseInfo.invoiceMoney}}</span>元</span>
        </p>
      </div>
      <span class="apply" @click="apply">申请发票</span>
    </div>
    <div class="content">
      <ul>
        <li class="item" @click="toDetail(item.id)" v-for="(item, index) in list" :key="item.id">
          <p>订单编号：{{item.orderSn}}</p>
          <p>身份证号码：{{userBaseInfo.id}}</p>
          <p>手机号码：{{userBaseInfo.mobile}}</p>
          <p>账号信息：{{item.remark}}</p>
          <span class="result">{{dealStatus(item.status)}}</span>
          <span class="cancel" v-if="(btnStatus(item.status)).length" @click.stop="confirm(item.status, item.id)">{{btnStatus(item.status)}}</span>
        </li>
      </ul>
      <div class="pagin">
        <pagination :pageCount="pageCount" @pageSize="pageSize" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import {reqInvoice, reqConfirmInvoice, reqCancelInvoice} from '../../../api'
import {mapState} from 'vuex'
export default {
  data() {
    return{
      list: [],
      pageCount: 0,
      userBaseInfo: '' // 发票额度
    }
  },
  created() {
    // 获取发票列表
    this._reqInvoice()
    // 判断是否存在userBaseInfo
    this.isUserInfo()

  },
  methods: {
    // 判断是否存在userBaseInfo
    isUserInfo() {
      if(JSON.stringify(this.$store.state.userBaseInfo) !== '{}'){
        this.userBaseInfo = this.$store.state.userBaseInfo
      } else {
        setTimeout(() => {
          this.userBaseInfo = this.$store.state.userBaseInfo
        },500)
      }
    },
    // 获取发票列表
    _reqInvoice(val=1) {
      reqInvoice({pageSize:val}).then(res => {
        if(res.code === 200){
          this.pageCount = res.data.pageCount
          this.list = res.data.bussData
        }
      })
    },
    toDetail (id) {
      this.$router.push({name: 'BillDetail', query: {id}})
    },
    apply () {
      this.$router.push('/person/bill/apply?price='+this.$refs.price.innerText)
    },
    // 处理状态
    dealStatus (val) {
      switch (Number(val)) {
        case -1 :
          return '已取消'
        case 1 :
          return '受理中'
        case 2 :
          return '待收货'
        case 3 :
          return '已收货'
      }
    },
    // 按钮状态
    btnStatus (val) {
      switch (Number(val)) {
        case -1 :
          return ''
        case 1 :
          return '取消订单'
        case 2 :
          return '确认订单'
        case 3 :
          return ''
      }
    },
    // 分页
    pageSize(val) {
      this._reqInvoice(val)
    },
    // 确认收货
    confirm(status, id) {
      if(status === '1'){
        reqCancelInvoice(id).then(res => {
          if(res.code === 200) {
            this._reqInvoice()
            this.isUserInfo()
            this.$store.dispatch('changeInvoice', {invoiceMoney: res.data.bussData, bool: 'false'})
          }
        })
      } else if(status === '2'){
        reqConfirmInvoice(id).then(res => {
          if(res.code === 200) {
            this._reqInvoice()
            this.isUserInfo()
          }
        })
      }
    }
  },
  computed: {
    // ...mapState(['userBaseInfo'])
  },
  components: {
    Pagination
  }
}
</script>

<style scoped lang="less" type="text/less">
.bill{
  .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top:60px;
    .left{
      h3{
        font-size: 24px;
        margin-bottom: 20px;
      }
      p{
        font-size: 16px;
        span{
          color:#E60012;
        }
      }
    }
    .apply{
      display: block;
      width: 110px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      background: #2FA1DE;
      color:#fff;
      border-radius: 20px;
      cursor: pointer;
    }
  }
  .content{
    margin-top:40px;
    .item{
      position: relative;
      width:900px;
      height:200px;
      padding:22px 20px 38px;
      box-sizing: border-box;
      box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
      border-radius:10px;
      cursor: pointer;
      p{
        margin-bottom: 30px;
      }
      .result{
        position: absolute;
        top: 21px;
        right: 21px;
      }
      .cancel{
        position: absolute;
        right: 30px;
        bottom: 20px;
        display: inline-block;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border:1px solid #999;
        font-size: 16px;
        border-radius: 20px;
        cursor: pointer;
      }
    }
    .pagin{
      margin-top:40px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Bill.vue